import React from 'react'
import { BoxProps, Hide, HStack, IconButton, Stack, StackProps, Text, VStack } from '@chakra-ui/react'
import { themeColors } from 'theme'

import { Breadcrumbs } from 'components/Breadcrumbs'
import { CarrouselLeftIcon } from 'components/SVGS'

interface CardCustomProps {
  children: React.ReactElement | React.ReactNode
  onClose?: () => void
  headerText?: string
  hiddenStack?: boolean
  isFullScreen?: boolean
  isScreen?: boolean
}

interface CardComponentProps {
  children: React.ReactElement | React.ReactNode
  onClose?: () => void
  headerText?: string
  hiddenStack?: boolean
  isFullScreen?: boolean
}

const CardComponent = ({
  children, onClose, headerText, hiddenStack = true, isFullScreen, ...props
}: CardComponentProps & StackProps & BoxProps) => {
  const { card: { bgColor, bgBorderColor } } = themeColors

  return (
    <VStack
      as="form"
      spacing={10}
      mx="auto"
      py={10}
      px={4}
      w={'100%'}
      minH={isFullScreen ? 'calc(100vh - 102px)' : 'auto'}
      alignItems={'center'}
      justifyContent={'center'}
      borderRadius={'24px'}
      borderWidth={3}
      borderColor={bgBorderColor}
      bg={bgColor}
      {...props}>
      {(!hiddenStack) && (headerText || onClose) && <Stack
        h={'auto'}
        flexDirection={{ base: 'column', md: 'row' }}
        justifyContent={'flex-start'}
        alignItems={'center'}
        w={'full'}>
        {onClose &&
          <Hide below='md'>
            <IconButton
              h={'full'}
              variant={'unstyled'}
              aria-label='ChevronLeftIcon'
              onClick={onClose}
              icon={<CarrouselLeftIcon fill={'white'} size={7} />}
            />
          </Hide>
        }
        {headerText &&
          <HStack justifyContent={'center'} alignItems={'flex-start'} w={'full'} h={'full'}>
            <Text variant={'LG_SB'} textAlign={'center'}>{headerText}</Text>
          </HStack>
        }
      </Stack>}
      {children}
    </VStack>
  )
}

export const CardContainer = ({
  children, onClose, headerText, hiddenStack = true, isFullScreen, isScreen, ...props
}: CardCustomProps & StackProps & BoxProps) => {
  return (
    !isScreen
      ? <CardComponent
        onClose={onClose}
        headerText={headerText}
        isFullScreen={isFullScreen}
        hiddenStack={hiddenStack}
        {...props}>
        {children}
      </CardComponent>
      : <VStack spacing={4}>
        <Breadcrumbs />
        <CardComponent
          onClose={onClose}
          headerText={headerText}
          isFullScreen={isFullScreen}
          hiddenStack={hiddenStack}
          {...props}>
          {children}
        </CardComponent>
      </VStack>
  )
}
